import Vue from "vue"
import axios from "axios";
import VueAxios from "vue-axios";
import {API_URL} from "./config";

const ApiService = {
    init() {
        Vue.use(VueAxios, axios);
        Vue.axios.defaults.baseURL = API_URL;
    },
    query(resource, params) {
        return Vue.axios.get(resource, params).catch(error => {
            throw new Error(`[RWV] ApiService ${error}`);
        });
    },
    get(resource, slug = "", params) {
        return Vue.axios.get(`${resource}/${slug}`, {params: params}).catch(error => {
            throw new Error(`[RWV] ApiService ${error}`);
        });
    },
    post(resource, params) {
        return Vue.axios.post(`${resource}`, params);
    },
    update(resource, slug, params) {
        return Vue.axios.put(`${resource}/${slug}`, params);
    },

    put(resource, params) {
        return Vue.axios.put(`${resource}`, params);
    },
    delete(resource) {
        return Vue.axios.delete(resource).catch(error => {
            throw new Error(`[RWV] ApiService ${error}`);
        });
    }
};

export default ApiService;

export const AlarmsService = {
    listAlarms(slug) {
        return ApiService.query("alarms", slug);
    },
    addAlarm(slug, payload) {
        return ApiService.post(`alarms`, payload)
    },
    deleteAlarm(slug, id) {
        return ApiService.delete(`alarms/${id}`)
    },
};

export const StocksService = {
    listExchanges() {
        return ApiService.query("exchanges");
    },
    listStocksForExchange(exchangeId) {
        return ApiService.query(`exchanges/${exchangeId}/stocks`, "")
    }
};
